import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-rfi-change-history',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './rfi-change-history.component.html',
  styleUrl: './rfi-change-history.component.css'
})
export class RfiChangeHistoryComponent {
  changeHistory = [
    {
      date: 'Thu Jan 1, 2025 at 04:06 pm Pak',
      actionBy: 'Pat Project Manager',
      changed: 'Added discussion group member',
      from: '(None)',
      to: 'Sam S'
    },
    {
      date: 'Thu Jan 1, 2025 at 04:06 pm Pak',
      actionBy: 'Pat Project Manager',
      changed: 'Added discussion group member',
      from: '(None)',
      to: 'Sam S'
    },
    {
      date: 'Thu Jan 1, 2025 at 04:06 pm Pak',
      actionBy: 'Pat Project Manager',
      changed: 'Added discussion group member',
      from: '(None)',
      to: 'Sam S'
    },
    {
      date: 'Thu Jan 1, 2025 at 04:06 pm Pak',
      actionBy: 'Pat Project Manager',
      changed: 'Added discussion group member',
      from: '(None)',
      to: 'Sam S'
    }
  ];
}
